import { useState } from "react"
import { faBan, faCheckCircle } from "@fortawesome/free-solid-svg-icons"

import ButtonPrimary from "components/ButtonPrimary"
import Input from "components/Input"
import Modal from "components/Modal"

import { isValid, discectError } from 'lib/utils'
import { USER_TYPES } from "lib/user-utils"

import styles from "./styles.module.scss"

const ReportFilterModal = ({ error: incomingError, onSave, onClose }) => {
  const [info, setInfo] = useState(null)
  const [error, setError] = useState(null)

  const _onSave = () => {
    try {
      if (isValid(info, ['userType', 'nameFirst', 'nameLast', 'email', 'phone'])) {
        onSave(info)
      } else {
        throw new Error('Please make sure you have filled out all required fields.')
      }
    } catch(e) {
      setError(discectError(e))
    }
  }

  const _onTextChange = (id, val) => setInfo(i => { return { ...i, [id]: val } })

  return (
    <Modal>
      <div className={styles.modalWindow__section}>
        <h5 className="rad">Add User</h5>
        {(incomingError || error) && <p className="error">{incomingError || error}</p>}
        <div className={styles.splitForm}>
          <Input isRequired type="select" id="userType" label="User Type" defaultValue={info?.userType || ''} dropdownOptions={USER_TYPES} onChange={_onTextChange} />
        </div>
        <div className={styles.splitForm}>
          <Input isRequired type="text" id="nameFirst" label="First Name" value={info?.nameFirst || ''} onChange={_onTextChange} />
          <Input isRequired type="text" id="nameLast" label="Last Name" value={info?.nameLast || ''} onChange={_onTextChange} />
        </div>
        <div className={styles.splitForm}>
          <Input isRequired type="text" id="email" label="Email Address" value={info?.email || ''} onChange={_onTextChange} />
          <Input isRequired type="tel" id="phone" label="Phone Number" value={info?.phone || ''} onChange={_onTextChange} />
        </div>
      </div>
      <div className={styles.modalWindow__actions}>
        <ButtonPrimary color="grey" icon={faBan} onClick={onClose}>Back</ButtonPrimary>
        <ButtonPrimary color="navy" icon={faCheckCircle} onClick={() => _onSave()}>Save</ButtonPrimary>
      </div>
    </Modal>
  )
}

export default ReportFilterModal
